import axios from 'axios'
import moment from 'moment'
import CONSTANTS from '@/src/constants'
import Helper from '@/src/utils/helper'
import JWT from 'jsonwebtoken'
import _ from 'lodash'
import $ from '@/src/plugins/vue-gridform/shared/helper'

const _ISDEV = process.env.VUE_APP_DEV === 'true'
const _ISDEVX = process.env.VUE_APP_EXPERIMENTAL === 'true'
const _DEBUG = process.env.NODE_ENV === 'development'
const _LOG = function() {
    if (_DEBUG) console.log.apply(console, arguments)
}
const _LOG_TOKEN = token => {
    const decoded = JWT.decode(token)
    console.log('decoded', JSON.stringify(decoded, null, 2))
}

const _BUILD_DATE = (date, time, defaultTime) => {
    if (!date) return ''
    if (CONSTANTS.REGEXP.DATETIME.test(date)) {
        return moment(date, 'YYYY-MM-DD HH:mm').toISOString()
    }

    if (!CONSTANTS.REGEXP.DATE.test(date)) console.warn('wrong date', date)
    const mom = moment(date, 'YYYY-MM-DD')
    let ts
    if (time && CONSTANTS.REGEXP.TIME.test(time)) {
        ts = time.split(':')
        mom.set({hours: ts[0], minutes: ts[1]})
    }
    else if (defaultTime && CONSTANTS.REGEXP.TIME.test(defaultTime)) {
        ts = defaultTime.split(':')
        mom.set({hours: ts[0], minutes: ts[1]})
    }
    return mom.toISOString()
}
const _GET_DATES = (coaching, data) => {
    let coachingDate = data.coachingDate
    let reminderDate = data.reminderDate
    let finishedDate = coaching.finished || data.finishedDate
    let date
    let time

    const flattenConfig = _.flatten(data.config)

    // fallback for old coachings without coachingDate in data object
    if (typeof coachingDate === 'undefined') {
        const fieldCoachingDate = flattenConfig.find(field => field.name === 'coachingDate')
        if (fieldCoachingDate) date = fieldCoachingDate.value
        const fieldCoachingTime = flattenConfig.find(field => field.name === 'coachingDateTime')
        if (fieldCoachingTime) time = fieldCoachingTime.value
        coachingDate = _BUILD_DATE(date, time, '12:00')
    }
    if (CONSTANTS.REGEXP.DATE.test(coachingDate)) {
        const fieldCoachingTime = flattenConfig.find(field => field.name === 'coachingDateTime')
        if (fieldCoachingTime) time = fieldCoachingTime.value
        coachingDate = _BUILD_DATE(coachingDate, time, '12:00')
    }

    // fallback for old coachings without reminderDate in data object
    if (typeof coaching.reminderDate === 'undefined') {
        const fieldReminderDate = flattenConfig.find(field => field.name === 'reminder')
        if (fieldReminderDate) date = fieldReminderDate.value
        const fieldReminderTime = flattenConfig.find(field => field.name === 'reminderTime')
        if (fieldReminderTime) time = fieldReminderTime.value
        reminderDate = _BUILD_DATE(date, time, '08:00')
    }

    if (coaching.isFinished) {
        // NOTE when coaching is set to finished, we do not get back the finished date in response
        if (!finishedDate) finishedDate = moment().toISOString()
        // NOTE repair incorrect finished date to prevent errors in alphabetic sorting
        else finishedDate = moment.utc(finishedDate).toISOString()
    }
    else finishedDate = ''

    return {coachingDate, reminderDate, finishedDate}
}
// map coaching before set to state
// 1. calculate and append coaching rating and flag for weighted ratings
// 2. fallback for finished date, when only isFinished is set
// 3. fallback for coaching date, detect coaching date from coaching
// 4. detect username from coaching data
// 5. detect reminder from coaching data
// 6. omit coaching.audit (for now)
const _MAP_COACHING = coaching => {
    const data = Helper.coachingToData(coaching)
    coaching.duration = data.duration || 0
    coaching.rating = Helper.coachingToRating(coaching)
    coaching.ratingIsWeighted = _.get(coaching.rating, 'score') !== _.get(coaching.rating, 'wscore')

    const dates = _GET_DATES(coaching, data)
    coaching.coachingDate = dates.coachingDate
    coaching.reminderDate = dates.reminderDate
    coaching.finished = dates.finishedDate
    if (coaching.isFinished !== !!coaching.finished) console.warn('isFinished wrong', coaching)
    coaching.isFinished = !!coaching.finished

    // get coaching user from config
    const username = _.find(_.flatten(data.config), {name: 'username'})
    coaching.username = username && username.value ? username.value : null

    // get reminder date from config
    coaching.overdue = false
    coaching.fromNow = null
    if (coaching.reminderDate) {
        const rd = moment(coaching.reminderDate)
        const diff = rd.diff(moment(), 'h')
        coaching.overdue = diff < 0
        coaching.fromNow = rd.fromNow()
    }

    // remove not needed props
    delete coaching.audit

    return coaching
}

export const state = {
    userToken: null,
    userGroup: null,
    userGroups: [], // list of all user groups
    userInvitations: [], // all pending invitations
    organisations: [], // all organisation from current session user
    organisation: {}, // current organisation from current session user
    organisationUsers: [], // all user in current organisation
    organisationUsersMap: {}, // all user in current organisation as map userId = username
    organisationInvitations: [], // all pending users in current organisation
    organisationBlocks: [],
    organisationOverview: {}, // all statistics for the current organization
    organisationHistory: {}, // history for the current organization
    templates: [],
    templatesExtended: [], // with field and fieldlist information
    blocks: [],
    blockGroups: [],
    coachings: [],
    coachingUnits: [],
    coachingsFilter: {}, // current filter for coachings advanced search
    coachingsFilterList: {}, // saved coachings filter
    lineChartFilter: {}, // current filter for reporting line chart
    events: [], // data with events {name, start, end, color}
    fetching: {
        initial: true, // is set to false after first fetching
        active: true, // {active: true/false} set while data from organisation is loading
        change: false, // {change: true/false} set when organization changed and loading
        disabled: false // {disabled: true/false} set when only load minimal organization data for a route
    },
    // NOTE temporary maps
    templateMap: {}
}

export const actions = {
    // reload states from local/session storage after login
    // because a logout clears the state
    INIT({ commit }) {
        commit('SET_COACHINGS_FILTER', Helper.getStore('state.coachingsFilter', {}))
        commit('SET_COACHINGS_FILTERLIST', Helper.getStore('state.coachingsFilterList', {}))
        commit('SET_LINECHART_FILTER', Helper.getStore('state.lineChartFilter', {}))
    },

    ACTIONTOKEN_VALID({}, actionTokenId) {
        if (!actionTokenId) return _LOG('ACTIONTOKEN_VALID: no action token')

        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ACTIONTOKEN_VALID, actionTokenId))
            .then(response => response.data)
    },

    //
    // ## USERS
    //

    // load single user by userId
    USERS_GET({ state }, {userId, keycloakId} = {}) {
        if (!Helper.isValidId(userId) && !Helper.isValidId(keycloakId)) return _LOG('USERS_GET: invalid id')
        if (!state.userToken) return _LOG('USERS_GET: no user token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const query = keycloakId ? 'fromKeycloakId=true' : ''
        const id = keycloakId || userId
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.USERS_GET, id, query), {headers})
            .then(response => _.get(response, 'data.user'))
            .catch(Helper.errorHandler)
    },

    // update user settings
    USERS_SETTINGS({ dispatch, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('USERS_SETTINGS: empty payload')
        if (!Helper.isValidId(payload.userId)) return _LOG('USERS_SETTINGS: invalid userId')
        if (!state.userToken) return _LOG('USERS_SETTINGS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_SETTINGS), payload, {headers})
            .then(response => {
                const successful = response.status === 200
                if (successful) dispatch('auth/settings', payload, {root: true})
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // create new admin user
    // {
    //   "Username": "JillValentine",
    //   "Lastname": "Valentine",
    //   "Email": "JV@voixen.com",
    //   "Firstname": "Jill"
    // }
    USERS_CREATE({ dispatch, commit, state }, payload) {
        if (_.isEmpty(payload) || !payload.username) return _LOG('USERS_CREATE: invalid payload')

        payload.isKeycloakUser = true

        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.USERS_CREATE), payload)
            .then(response => {
                return {userId: _.get(response, 'data.user.userId')}
            })
            .catch(response => {
                const errorStatus = _.get(response, 'response.status')
                const errorMessage = _.get(response, 'response.data.errorMessage')
                if (errorStatus === 400 && errorMessage === 'User exists with same username') {
                    return {message: 'usernameExists'}
                }
                else Helper.errorHandler(response)
            })
    },

    // update single user
    USERS_UPDATE({ dispatch, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('USERS_UPDATE: empty payload')
        if (!Helper.isValidId(payload.userId)) return _LOG('USERS_UPDATE: invalid userId', payload)
        if (!state.userToken) return _LOG('USERS_UPDATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_UPDATE), payload, {headers})
            .then(response => {
                const successful = response.status === 202
                if (successful) dispatch('ORG_USERS', {organisationId: state.organisation.organisationId})
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // reset password of single user
    USERS_RESET_PW({ state }, {userId, oldPassword, newPassword} = {}) {
        if (!Helper.isValidId(userId) || !oldPassword || !newPassword) return _LOG('USERS_RESET_PW: invalid payload')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const data = {userId, oldPassword, newPassword}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_RESET_PW), data, {headers})
            .then(response => response.status === 200)
            .catch(Helper.errorHandler)
    },
    // send password reset mail to single user
    USERS_FORGOT_PW({ state }, {username, actionToken, newPassword} = {}) {
        if (!username) return _LOG('USERS_FORGOT_PW: invalid payload')

        const data = {}
        data.username = username
        if (actionToken && newPassword) {
            data.actionToken = actionToken
            data.newPassword = newPassword
        }
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_FORGOT_PW), data)
            .then(response => response.status === 200)
            .catch(Helper.errorHandler)
    },

    USERS_VERIFY({}, {token} = {}) {
        if (!token) return _LOG('USERS_VERIFY: invalid payload')

        const data = {actionToken: token}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_VERIFY), data)
            .then(response => response.status === 200)
    },

    // delete single user
    USERS_DELETE({ dispatch, commit, state }, {userId} = {}) {
        if (!['Administrator'].includes(state.userGroup)) return _LOG('ORG_USERS: invalid group')
        if (!Helper.isValidId(userId)) return _LOG('USERS_DELETE: invalid userId')

        const organisationId = state.organisation.organisationId
        if (!Helper.isValidId(organisationId)) return _LOG('USERS_DELETE: invalid organisationId')
        if (!state.userToken) return _LOG('USERS_DELETE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.USERS_DELETE, userId), {headers})
            .then(() => {
                dispatch('ORG_USERS', {organisationId})
            })
            .catch(Helper.errorHandler)
    },

    // get user organisation details from list of organisation ids
    USER_ORGS({ commit, dispatch, state }, payload) {
        if (_.isEmpty(payload)) {
            commit('SET_FETCHING', {active: false})
            return
        }
        if (!Array.isArray(payload)) return _LOG('USER_ORGS: invalid payload')
        if (!state.userToken) return _LOG('USER_ORGS: no token')

        // build map to set organizationGroup of user to organizations
        const orgMap = {}
        payload.forEach(org => { orgMap[org.organizationId] = org })

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }
        const ids = payload.map(org => _.get(org, 'organizationId'))
        // NOTE use POST request to prevent too long url
        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.ORG_LIST), { OrganizationIdList: ids }, config).then(response => {
            const orgs = _.get(response, 'data.organisations', []).filter(org => !!org)
            orgs.forEach(org => {org.organizationGroup = orgMap[org.organisationId].organizationGroup})
            dispatch('ORG_SESSION', orgs)
            return orgs
        })
    },

    // user has accept an invitation to an organization
    USERS_ACCEPT_INVITATION({ dispatch, state, rootState }, {actionTokenId} = {}) {
        if (!actionTokenId) return _LOG('USERS_ACCEPT_INVITATION: missing action token')
        if (!state.userToken) return _LOG('USERS_ACCEPT_INVITATION: no user token')

        const payload = {actionTokenId}
        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.USERS_ACCEPT_INVITATION), payload, config)
            .then(response => {
                const successful = response.status === 200
                if (successful) dispatch('auth/refreshToken', null, {root: true})
                return successful
            })
            .catch(error => {
                const data = _.get(error, 'response.data')
                const status = _.get(error, 'response.status')
                if (status === 400 && /^ActionToken.*not found$/i.test(data)) {
                    return 'invalid'
                }
                else Helper.errorHandler(error)
            })
    },

    USERS_INVITATIONS({ commit, state, rootState }, {userId} = {}) {
        userId = userId || _.get(rootState, 'auth.currentUser.user.userId') // set current user as default
        if (!Helper.isValidId(userId)) return _LOG('USERS_INVITATIONS: invalid userId')
        if (!state.userToken) return _LOG('USERS_INVITATIONS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.USERS_INVITATIONS, userId), config)
            .then(response => {
                const invitations = _.get(response, 'data.userInvitations', [])
                commit('SET_USER_INVITATIONS', invitations)
                return invitations
            })
            .catch(Helper.errorHandler)
    },

    //
    // ## ORGANISATIONS
    //

    // load all organisations
    ORG_ALL({ dispatch }) {
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_ALL))
            .then(response => {
                const orgs = _.get(response, 'data.organisations', [])
                dispatch('ORG_SESSION', orgs)
                return orgs
            })
            .catch(Helper.errorHandler)
    },

    // load single organisation by id
    ORG_GET({ state }, organisationId) {
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_GET: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_GET: no user token')

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_GET, organisationId), config)
            .then(response => _.get(response, 'data.organisation'))
            .catch(Helper.errorHandler)
    },

    // create a new organisation for the current user
    ORG_CREATE({ commit, dispatch, getters, state }, payload) {
        if (_.isEmpty(payload)) return
        // TODO create validator for entities (what is required?)
        if (!payload.name || !payload.initials) return
        if (!state.userToken) return _LOG('ORG_CREATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.ORG_CREATE), payload, config)
            .then(async response => {
                const successful = response.status === 201
                if (successful) await dispatch('auth/refreshToken', null, {root: true})
                const organisation = _.get(response, 'data.organisation')
                if (organisation) organisation.organizationGroup = CONSTANTS.GROUP_ADMIN
                return organisation
            })
            .catch(Helper.errorHandler)
    },

    // update existing organisation
    ORG_UPDATE({ commit, dispatch, getters, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('ORG_UPDATE: no payload')
        if (!Helper.isValidId(payload.organisationId)) return _LOG('ORG_UPDATE: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_UPDATE: no token')

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.ORG_UPDATE), payload, config)
            .then(async response => {
                const successful = response.status === 200
                if (successful) {
                    await dispatch('auth/refreshToken', null, { root: true })
                    const orgs = getters.organisations.map(org => {
                        return org.organisationId === payload.organisationId
                            ? Object.assign({}, org, payload)
                            : org
                    })
                    dispatch('ORG_SESSION', orgs)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // delete organisation by id
    ORG_DELETE({ dispatch, getters, state }, {organisationId} = {}) {
        if (!getters.canDelete) return
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_DELETE: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_DELETE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.ORG_DELETE, organisationId), config)
            .then(response => {
                const orgs = getters.organisations.filter(org => org.organisationId !== organisationId)
                dispatch('ORG_SESSION', orgs)
                return response.status === 200
            })
            .catch(Helper.errorHandler)
    },

    // set session organisations
    ORG_SESSION({ commit, dispatch, getters, rootGetters }, orgs) {
        if (!rootGetters['auth/loggedIn']) return
        if (_.isEmpty(orgs)) {
            dispatch('RESET')
            return
        }

        commit('SET_ORGANISATIONS', orgs)

        let activeOrg

        // set last used org
        const lastOrgId = _.get(rootGetters['auth/settings'], 'lastOrganisationId')
        if (lastOrgId) activeOrg = orgs.find(org => org.organisationId === lastOrgId)
        // or the first one
        if (!activeOrg) activeOrg = _.first(orgs)

        dispatch('ORG_ACTIVE', activeOrg)
    },

    // set current organisation
    // load users for organisation
    // load agents for organisation
    ORG_ACTIVE({ dispatch, commit, state }, organisation) {
        if (!organisation) return
        if (!Helper.isValidId(organisation.organisationId)) return _LOG('ORG_ACTIVE: invalid organisationId')
        if (!CONSTANTS.GROUPS.includes(organisation.organizationGroup)) return _LOG('ORG_USERGROUP: invalid organizationGroup')

        commit('SET_FETCHING', { change: true })

        // update user group
        commit('auth/SET_USER_GROUP', organisation.organizationGroup, { root: true })
        commit('SET_USER_GROUP', organisation.organizationGroup)

        // set active organization
        commit('SET_ORGANISATION', organisation)

        // clear coachings to reset charts, after fetch new data will be displayed
        commit('SET_COACHINGS', [])

        return dispatch('ORG_FETCH', organisation).then(() => {
            commit('SET_FETCHING', { change: false })
        })
    },

    // fetch organisation based states
    async ORG_FETCH({ dispatch, commit, state, rootState }, organisation) {
        if (!organisation) return
        if (!Helper.isValidId(organisation.organisationId)) return _LOG('ORG_FETCH: invalid organisationId')

        // TODO skip fetch if fetching is already active?
        if (!state.fetching.initial && state.fetching.active) console.warn('fetching already active')
        commit('SET_FETCHING', { active: true })

        // ## clear current organization state (if not auto-reload call)
        const isAutoReload = !!organisation.autoReload
        _.unset(organisation, 'autoReload')
        if (!isAutoReload) await dispatch('RESET_DATA')

        const promises = []
        if (['Administrator', 'Coach'].includes(state.userGroup)) {
            // we do not need all data for some routes (coaching = create new coaching)
            if (state.fetching.disabled) {
                promises.push(
                    dispatch('ORG_USERS', organisation),
                    dispatch('ORG_BLOCKS', organisation),
                    dispatch('ORG_TPLS', organisation)
                )
            }
            else {
                promises.push(
                    dispatch('ORG_OVERVIEW', organisation),
                    dispatch('ORG_HISTORY', organisation),
                    dispatch('ORG_USERS', organisation),
                    dispatch('ORG_COACHING', organisation),
                    dispatch('COACHING_UNIT_LIST', organisation),
                    dispatch('ORG_INVITATIONS', organisation),
                    dispatch('ORG_BLOCKS', organisation),
                    dispatch('ORG_TPLS', organisation)
                )
            }
        }
        // load coachings from org (will return only coachings from current user)
        else if (['EmployeeSmart'].includes(state.userGroup)) {
            // dispatch('RESET_DATA')
            // put the current user as map, needed for username mapping for coachings
            const {userId, username} = rootState.auth.currentUser.user
            commit('SET_ORGANISATIONS_USER_MAP', {[userId]: username})
            promises.push(
                dispatch('ORG_OVERVIEW', organisation),
                dispatch('ORG_HISTORY', organisation),
                dispatch('ORG_COACHING', organisation)
            )
        }

        return Promise.all(promises).then(() => {
            commit('SET_FETCHING', { initial: false, active: false })
        })
    },
    ORG_USERS({ commit, state }, {organisationId} = {}) {
        if (!['Administrator', 'Coach'].includes(state.userGroup)) return _LOG('ORG_USERS: invalid group')
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_USERS: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_USERS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_USERS, organisationId), config)
            .then(response => {
                const users = _.get(response, 'data.organisationUsers.users')
                commit('SET_ORGANISATIONS_USER', users)
            })
            .catch(Helper.errorHandler)
    },
    ORG_BLOCKS({ commit, dispatch, state }, {organisationId} = {}) {
        if (!['Administrator', 'Coach'].includes(state.userGroup)) return _LOG('ORG_BLOCKS: invalid group')
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_BLOCKS: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_BLOCKS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_BLOCKS, organisationId), config)
            .then(response => {
                const blocks = _.get(response, 'data.organisationBuildingBlocks.buildingBlocks', [])
                commit('SET_ORGANISATIONS_BLOCKS', blocks)
                dispatch('BUILD_BLOCKS')
            })
            .catch(Helper.errorHandler)
    },
    ORG_TPLS({ commit, dispatch, state }, {organisationId} = {}) {
        if (!['Administrator', 'Coach'].includes(state.userGroup)) return _LOG('ORG_TPLS: invalid group')
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_TPLS: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_TPLS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_TPLS, organisationId), config)
            .then(response => {
                const templates = _.get(response, 'data.organisationTemplates.templates', [])
                // TODO check audit
                dispatch('TPLS', templates)
                return templates
            })
            .catch(Helper.errorHandler)
    },
    /* Filter:
      Page (int)
      PageSize (int)
      From (DateTime string)
      To (DateTime string)
      EmployeeIds (string array)
      TemplateIds (string array)
      FromDuration (int)
      ToDuration (int)
      FromScore (int)
      ToScore (int)
      Status (string) // Momentan wird hier nur auf "finished" geprüft.
      orderby (string)
        created (default und immer 2. Sortierung)
        created desc
        finished
        finished desc
        employee
        employee desc
     */
    ORG_COACHING({ commit, dispatch, state }, {organisationId} = {}) {
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_COACHING: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_COACHING: no token')

        // const query = ''
        const query = `filter={PageSize:1000,OrderBy:'created desc'}`
        // const from = moment.utc().subtract(1, 'M').format()
        // const query = `filter={PageSize:1000,from:"${from}"}`
        // console.log('query', query)
        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_COACHING, organisationId, query), config)
            .then(async response => {
                let coachings = _.get(response, 'data', [])
                coachings = await dispatch('COACHING_MAP', coachings)
                commit('SET_COACHINGS', coachings)
                return coachings
            })
            .catch(Helper.errorHandler)
    },
    ORG_COACHING_QUERY({ dispatch, state }, {organisationId, filter} = {}) {
        organisationId = organisationId || state.organisation.organisationId
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_COACHING_QUERY: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_COACHING_QUERY: no token')

        const qprops = {
            PageSize: 1000
        }
        if (filter.fromScore) qprops.fromScore = filter.fromScore
        if (filter.toScore) qprops.toScore = filter.toScore
        const dateRange = $.calcDateRange(filter)
        if (dateRange) {
            if (dateRange.from) qprops.From = dateRange.from
            if (dateRange.to) qprops.To = dateRange.to
        }
        // if (filter.datefrom) qprops.From = filter.datefrom
        if (filter.employees) {
            qprops.EmployeeIds = Array.isArray(filter.employees) ? filter.employees : [filter.employees]
        }
        // if (filter.templates) qprops.TemplateIds = [filter.templates]
        if (filter.status && CONSTANTS.COACHING_FILTER_STATUS.includes(filter.status)) qprops.Status = filter.status
        const query = `filter=${JSON.stringify(qprops)}`
        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_COACHING, organisationId, query), config)
            .then(async response => {
                const coachings = _.get(response, 'data', [])
                if (_.isEmpty(coachings)) return []

                return await dispatch('COACHING_MAP', coachings)
            })
            .catch(Helper.errorHandler)
    },
    ORG_INVITATIONS({ commit, state }, {organisationId} = {}) {
        if (!['Administrator', 'Coach'].includes(state.userGroup)) return _LOG('ORG_INVITATIONS: invalid group')
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_INVITATIONS: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_INVITATIONS: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_INVITATIONS, organisationId), config)
            .then(response => {
                const invitations = _.get(response, 'data.organizationInvitations', [])
                commit('SET_ORGANISATIONS_INVITATIONS', invitations)
                return invitations
            })
            .catch(Helper.errorHandler)
    },
    ORG_OVERVIEW({ commit, state }, {organisationId} = {}) {
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_OVERVIEW: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_OVERVIEW: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_OVERVIEW, organisationId), config)
            .then(response => {
                commit('SET_ORGANISATION_OVERVIEW', response.data)
            })
            .catch(Helper.errorHandler)
    },
    ORG_HISTORY({ commit, state }, {organisationId} = {}) {
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_HISTORY: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_HISTORY: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.ORG_HISTORY, organisationId), config)
            .then(response => {
                const history = _.get(response, 'data', [])
                commit('SET_ORGANISATION_HISTORY', history)
                return history
            })
            .catch(Helper.errorHandler)
    },

    ORG_INVITATION_DELETE({ dispatch, state }, {organisationId, actionTokenId} = {}) {
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_INVITATION_DELETE: invalid organisationId')
        if (!actionTokenId) return _LOG('ORG_INVITATION_DELETE: no action token')
        if (!state.userToken) return _LOG('ORG_INVITATION_DELETE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.ORG_INVITATION_DELETE, [organisationId, actionTokenId]), config)
            .then(response => {
                const successful = response.status === 200
                if (successful) dispatch('ORG_INVITATIONS', {organisationId})
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // link an user to an organisation
    ORG_ORGUSER({ dispatch, state }, {userId, organisationId, organizationGroup} = {}) {
        if (!Helper.isValidId(userId) || !Helper.isValidId(organisationId)) return _LOG('ORG_ORGUSER: invalid payload')
        if (!organizationGroup) return _LOG('ORG_ORGUSER: no group name')
        if (!state.userToken) return _LOG('ORG_ORGUSER: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.ORG_ORGUSER), {userId, organisationId, organizationGroup}, config)
            .then(async response => {
                const successful = response.status === 200
                if (successful) await dispatch('auth/refreshToken', null, {root: true})
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // set an user to an organization group
    ORG_USERGROUP({ dispatch, state }, {userId, organisationId, organizationGroup} = {}) {
        if (!Helper.isValidId(userId)) return _LOG('ORG_USERGROUP: invalid user id')
        if (!CONSTANTS.GROUPS.includes(organizationGroup)) return _LOG('ORG_USERGROUP: invalid organizationGroup')
        if (!state.userToken) return _LOG('ORG_USERGROUP: no user token')

        organisationId = organisationId || state.organisation.organisationId
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_USERGROUP: invalid organizationId')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.ORG_USERGROUP), {userId, organisationId, organizationGroup}, config)
            .then(response => {
                const successful = response.status === 200
                if (successful) dispatch('ORG_USERS', {organisationId})
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // create organisation employee
    ORG_EMPLOYEE_CREATE({ dispatch, commit, getters, state, rootState }, payload) {
        if (_.isEmpty(payload)) return _LOG('ORG_EMPLOYEE_CREATE: empty payload')

        // set current organisation as fallback
        payload.organisationId = payload.organisationId || getters.organisation.organisationId
        if (!Helper.isValidId(payload.organisationId)) return _LOG('ORG_EMPLOYEE_CREATE: invalid organisationId')
        if (!CONSTANTS.GROUPS.includes(payload.organizationGroup)) return _LOG('ORG_EMPLOYEE_CREATE: invalid organizationGroup')
        if (!state.userToken) return _LOG('ORG_EMPLOYEE_CREATE: no user token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.ORG_USER), payload, config)
            .then(response => {
                const successful = response.status === 200 || response.status === 201
                if (successful) {
                    // TODO response should have new list of employees
                    dispatch('ORG_USERS', {organisationId: payload.organisationId}).then(() => {
                        dispatch('ORG_INVITATIONS', {organisationId: payload.organisationId})
                    })
                    // const currentUserId = _.get(rootState, 'auth.currentUser.user.userId')
                    // const employees = _.get(response, 'data.organisationUsers.users', []).filter(user => {
                    //   return user.userId !== currentUserId
                    // })
                    // commit('SET_ORGANISATIONS_EMPLOYEES', employees)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    // create organisation employee
    ORG_EMPLOYEE_DELETE({ dispatch, commit, getters, state }, {organisationId, userId} = {}) {
        // set current organisation as fallback
        organisationId = organisationId || getters.organisation.organisationId
        if (!Helper.isValidId(organisationId)) return _LOG('ORG_EMPLOYEE_DELETE: invalid organisationId')
        if (!Helper.isValidId(userId)) return _LOG('ORG_EMPLOYEE_DELETE: invalid userId')
        if (!state.userToken) return _LOG('ORG_EMPLOYEE_DELETE: no user token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.ORG_USERS, [organisationId, userId]), config)
            .then(response => {
                const successful = response.status === 200 || response.status === 201
                if (successful) {
                    // TODO response should have new list of employees
                    dispatch('ORG_USERS', {organisationId})
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // invite user to organisation by sending invitation email
    ORG_INVITE({ getters, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('ORG_INVITE: empty payload')
        if (!Helper.isValidId(payload.userId)) return _LOG('ORG_INVITE: invalid userId')
        if (!payload.inviteeEmail) return _LOG('ORG_INVITE: missing invitee email')
        if (!payload.permissionGroup) return _LOG('ORG_INVITE: missing permission group')

        // set current organisation as fallback
        payload.organisationId = payload.organisationId || getters.organisation.organisationId
        if (!Helper.isValidId(payload.organisationId)) return _LOG('ORG_INVITE: invalid organisationId')
        if (!state.userToken) return _LOG('ORG_INVITE: no user token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.ORG_INVITE), payload, config)
            .then(response => response.status === 201)
            .catch(Helper.errorHandler)
    },

    ORG_SEND_PDF({ state }, payload) {
        if (!state.userToken) return _LOG('ORG_SEND_PDF: no user token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.ORG_SEND_PDF), payload, config)
            .then(response => response.status === 200)
            .catch(Helper.errorHandler)
    },

    //
    // ## TEMPLATES
    //

    // create a new template for current organisation
    TPLS_CREATE({ commit, dispatch, getters, state }, template) {
        if (_.isEmpty(template)) return _LOG('TPLS_CREATE: empty payload')
        if (!template.name) return _LOG('TPLS_CREATE: missing name')
        if (_.isEmpty(template.config) && _.isEmpty(template.templateData)) return _LOG('TPLS_CREATE: missing config or templateData')
        if (!state.userToken) return _LOG('TPLS_CREATE: no token')

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }

        const initials = template.initials
        const name = template.name
        const description = template.description
        const currentOrganisationId = getters.organisation.organisationId
        const organisationId = template.organisationId || currentOrganisationId
        const templateData = template.templateData = template.config ? JSON.stringify({ config: template.config }) : template.templateData
        const payload = { initials, name, description, templateData, organisationId }

        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.TPLS_CREATE), payload, config)
            .then(response => {
                const template = _.get(response, 'data.templateLookup')
                if (template && organisationId === currentOrganisationId) {
                    const templates = [...getters.templates]
                    templates.push(template)
                    dispatch('TPLS', templates)
                }
                return template
            })
            .catch(Helper.errorHandler)
    },
    // update a template
    TPLS_UPDATE({ dispatch, getters, state }, template) {
        if (_.isEmpty(template) || !Helper.isValidId(template.templateId)) return _LOG('TPLS_UPDATE: invalid payload')
        if (_.isEmpty(template.config)) return _LOG('TPLS_UPDATE: missing config')
        if (!state.userToken) return _LOG('TPLS_UPDATE: no token')

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }

        template.templateData = JSON.stringify({config: template.config})
        const payload = _.pick(template, ['templateId', 'initials', 'name', 'description', 'templateData'])

        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.TPLS_UPDATE), payload, config)
            .then(response => {
                const successful = response.status === 202
                if (successful) {
                    const templates = getters.templates.map(template => {
                        return payload.templateId === template.templateId ? payload : template
                    })
                    dispatch('TPLS', templates)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    // delete a single template
    TPLS_DELETE({ commit, dispatch, getters, state }, template) {
        if (!getters.canDelete) return
        if (_.isEmpty(template) || !Helper.isValidId(template.templateId)) return
        if (!state.userToken) return _LOG('TPLS_DELETE: no token')

        const headers = { Authorization: `Bearer ${state.userToken}` }
        const config = { headers }
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.TPLS_DELETE, template.templateId), config)
            .then(response => {
                dispatch('ORG_TPLS', template)
                return response.status === 200
            })
            .catch(Helper.errorHandler)
    },

    // set templates
    // - build blocks
    TPLS({ commit, dispatch }, templates) {
        commit('SET_TEMPLATES', templates)
        dispatch('BUILD_BLOCKS')
    },

    //
    // ## BLOCKS
    //
    BLOCKS_CREATE({ commit, dispatch, getters, state }, block) {
        if (_.isEmpty(block)) return _LOG('BLOCKS_CREATE: empty payload')
        if (!block.name) return _LOG('BLOCKS_CREATE: missing name')
        if (_.isEmpty(block.config)) return _LOG('BLOCKS_CREATE: missing config')
        if (!state.userToken) return _LOG('BLOCKS_CREATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}

        const name = block.name
        const description = block.description
        const initials = block.initials
        const buildingBlockData = JSON.stringify({config: block.config})
        const organisationId = getters.organisation.organisationId
        const payload = {name, description, initials, buildingBlockData, organisationId}

        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.BLOCKS_CREATE), payload, config)
            .then(response => {
                const newBlock = _.get(response, 'data.buildingBlock')
                if (newBlock) {
                    const blocks = [...getters.organisationBlocks]
                    blocks.push(newBlock)
                    commit('SET_ORGANISATIONS_BLOCKS', blocks)
                    dispatch('BUILD_BLOCKS')
                }
                return newBlock
            })
            .catch(Helper.errorHandler)
    },
    BLOCKS_DELETE({ commit, getters, state }, {buildingBlockId} = {}) {
        if (!getters.canDelete) return
        if (!Helper.isValidId(buildingBlockId)) return _LOG('BLOCKS_DELETE: invalid buildingBlockId')
        if (!state.userToken) return _LOG('BLOCKS_DELETE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.BLOCKS_DELETE, buildingBlockId), config)
            .then(response => {
                console.log('response', response)
            })
            .catch(Helper.errorHandler)
    },
    // build blocks and block groups
    BUILD_BLOCKS({ commit, getters }) {
        const templates = getters.templates

        let blocks = []
        templates.forEach(template => {
            blocks = blocks.concat(Helper.templateToFields(template))
        })

        const orgBlocks = getters.organisationBlocks
        orgBlocks.forEach(block => {
            // TODO remove fieldlist data
            blocks = blocks.concat(Helper.blockToFields(block))
        })

        commit('SET_BLOCKS', blocks)

        let groups = []
        templates.forEach(template => {
            groups = groups.concat(Helper.templateToGroups(template))
        })

        commit('SET_BLOCK_GROUPS', groups)
    },

    //
    // ## COACHINGS
    //
    COACHING_GET({ state }, id) {
        if (!Helper.isValidId(id)) return _LOG('COACHING_GET: invalid coachingId')
        if (!state.userToken) return _LOG('COACHING_GET: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_GET, id), config)
            .then(response => _.get(response, 'data.coaching'))
    },
    COACHING_CREATE({ commit, dispatch, getters, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('COACHING_CREATE: empty payload')
        if (!Helper.isValidId(payload.userId)) return _LOG('COACHING_CREATE: invalid userId')
        if (!Helper.isValidId(payload.organisationId)) return _LOG('COACHING_CREATE: invalid organisationId')
        if (!state.userToken) return _LOG('COACHING_CREATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_CREATE), payload, config)
            .then(async response => {
                const coaching = _.get(response, 'data.coaching')
                if (coaching) {
                    const organisationId = payload.organisationId
                    await dispatch('ORG_COACHING', { organisationId })
                    if (payload.coachingUnitId) {
                        await dispatch('COACHING_UNIT_LIST', { organisationId })
                    }
                    // DEV #CD-218
                    // TODO created ist wrong, employeeName is missing
                    //  created: "0001-01-01T00:00:00"
                    //  employeeName: null
                    //  lastUpdated: "0001-01-01T00:00:00"
                    // const coachings = [...getters.coachings]
                    // const ncoaching = await dispatch('COACHING_MAP', coaching)
                    // coachings.push(ncoaching)
                    // commit('SET_COACHINGS', coachings)
                }
                return coaching
            })
            .catch(Helper.errorHandler)
    },
    COACHING_UPDATE({ commit, dispatch, getters, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('COACHING_UPDATE: empty payload')
        if (!Helper.isValidId(payload.coachingId)) return _LOG('COACHING_UPDATE: invalid coachingId')
        if (!state.userToken) return _LOG('COACHING_UPDATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}

        if (!_.isString(payload.coachingData)) payload.coachingData = JSON.stringify(payload.coachingData)

        // remove the calculated props from payload
        const coachingUpdate = _.omit(payload, ['duration', 'username', 'rating'])
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UPDATE), coachingUpdate, config)
            .then(async response => {
                const successful = response.status === 200
                if (successful) {
                    // TODO reload only current coaching
                    // const cid = await dispatch('COACHING_GET', payload.coachingId)
                    // console.log('cid', cid)
                    const coachings = getters.coachings.map(coaching => {
                        return coaching.id === payload.coachingId
                            // NOTE map update coaching to recalc rating
                            ? _MAP_COACHING(Object.assign({}, coaching, coachingUpdate))
                            : coaching
                    })
                    commit('SET_COACHINGS', coachings)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    COACHING_DELETE({ commit, getters, state }, {id} = {}) {
        if (!getters.canDelete) return
        if (!Helper.isValidId(id)) return _LOG('COACHING_DELETE: invalid coaching id')
        if (!state.userToken) return _LOG('COACHING_UPDATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        const config = {headers}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_DELETE, id), config)
            .then(response => {
                const successful = response.status === 200
                if (successful) {
                    const coachings = getters.coachings.filter(c => c.id !== id)
                    commit('SET_COACHINGS', coachings)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    COACHING_MAP({ state }, coachings) {
        const templateMap = state.templateMap
        // filter possible corrupted coaching entries
        const arrCoachings = _.castArray(coachings)
            .map(coaching => {
                // try to fix a stringified coaching record
                if (_.isString(coaching)) {
                    let coachingObj
                    try {
                        coachingObj = JSON.parse(coaching)
                        // validate the parsed coaching
                        if (Helper.coachingValidate(coachingObj)) {
                            return coachingObj
                        }
                    }
                    catch (e) {
                        console.error('damaged coaching recording detected', coaching)
                    }
                }
                return coaching
            })
            .filter(Helper.coachingValidate)
        return arrCoachings.map(map)

        function map(coaching) {
            coaching.templateInitials = _.get(templateMap[coaching.name], 'initials', coaching.name)
            coaching.templateId = _.get(templateMap[coaching.name], 'templateId', coaching.name)
            return _MAP_COACHING(coaching)
        }
    },

    //
    // ## COACHING UNITS
    //
    COACHING_UNIT_LIST({ commit, state }, {organisationId} = {}) {
        if (!Helper.isValidId(organisationId)) return _LOG('COACHING_UNIT_LIST: invalid organisationId')
        if (!state.userToken) return _LOG('COACHING_UNIT_LIST: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_LIST, null, `organisationId=${organisationId}`), {headers})
            .then(response => {
                const units = _.get(response, 'data.coachingUnits', [])
                commit('SET_COACHING_UNITS', units)
                return units
            })
            .catch(Helper.errorHandler)
    },
    COACHING_UNIT_GET({ state }, coachingUnitId) {
        if (!Helper.isValidId(coachingUnitId)) return _LOG('COACHING_UNIT_GET: invalid coachingUnitId')
        if (!state.userToken) return _LOG('COACHING_UNIT_GET: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.get(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_GET, coachingUnitId), {headers})
            .then(response => _.get(response, 'data.coachingUnit'))
            .catch(Helper.errorHandler)
    },
    COACHING_UNIT_CREATE({ dispatch, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('COACHING_UNIT_CREATE: empty payload')
        if (!Helper.isValidId(payload.organisationId)) return _LOG('COACHING_UNIT_CREATE: invalid organisationId')
        if (!state.userToken) return _LOG('COACHING_UNIT_CREATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.post(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_CREATE), payload, {headers})
            .then(async response => {
                const unit = _.get(response, 'data.coachingUnit')
                if (unit) {
                    await dispatch('COACHING_UNIT_LIST', {organisationId: payload.organisationId})
                }
                return unit
            })
            .catch(Helper.errorHandler)
    },
    COACHING_UNIT_UPDATE({ dispatch, state }, payload) {
        if (_.isEmpty(payload)) return _LOG('COACHING_UNIT_UPDATE: empty payload')
        if (!Helper.isValidId(payload.coachingUnitId)) return _LOG('COACHING_UNIT_UPDATE: invalid coachingUnitId')
        if (!state.userToken) return _LOG('COACHING_UNIT_UPDATE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_UPDATE), payload, {headers})
            .then(async response => {
                const successful = response.status === 204
                if (successful) {
                    await dispatch('COACHING_UNIT_LIST', {organisationId: state.organisation.organisationId})
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    COACHING_UNIT_SET_DONE({ dispatch, state }, coachingUnitId) {
        if (!Helper.isValidId(coachingUnitId)) return _LOG('COACHING_UNIT_SET_DONE: invalid coachingUnitId')
        if (!state.userToken) return _LOG('COACHING_UNIT_SET_DONE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.put(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_SET_DONE, coachingUnitId), null, {headers})
            .then(async response => {
                const successful = response.status === 204
                if (successful) {
                    await dispatch('COACHING_UNIT_LIST', {organisationId: state.organisation.organisationId})
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },
    COACHING_UNIT_DELETE({ commit, getters, state }, coachingUnitId) {
        if (!getters.canDelete) return
        if (!Helper.isValidId(coachingUnitId)) return _LOG('COACHING_UNIT_DELETE: invalid coachingUnitId')
        if (!state.userToken) return _LOG('COACHING_UNIT_DELETE: no token')

        const headers = {Authorization: `Bearer ${state.userToken}`}
        return axios.delete(Helper.apiUrl(CONSTANTS.ROUTES.COACHING_UNIT_DELETE, coachingUnitId), {headers})
            .then(response => {
                const successful = response.status === 204
                if (successful) {
                    const units = getters.coachingUnits.filter(u => u.id !== coachingUnitId)
                    commit('SET_COACHING_UNITS', units)
                }
                return successful
            })
            .catch(Helper.errorHandler)
    },

    // ## RESET STATES
    // states over all organizations
    RESET({ commit, dispatch }) {
        commit('SET_USER_TOKEN', null)
        commit('SET_USER_GROUP', null)
        commit('SET_ORGANISATIONS', [])
        commit('SET_ORGANISATION', {})
        // keyed with organisation-id
        commit('SET_COACHINGS_FILTER', {})
        commit('SET_COACHINGS_FILTERLIST', {})
        commit('SET_LINECHART_FILTER', {})
        dispatch('RESET_DATA')
    },
    // states for current organization
    RESET_DATA({ commit }) {
        commit('SET_ORGANISATIONS_USER_MAP', {})
        commit('SET_ORGANISATIONS_USER', [])
        commit('SET_ORGANISATION_OVERVIEW', {})
        commit('SET_ORGANISATION_HISTORY', [])
        commit('SET_ORGANISATIONS_INVITATIONS', [])
        commit('SET_ORGANISATIONS_BLOCKS', [])
        commit('SET_COACHINGS', [])
        commit('SET_COACHING_UNITS', [])
        commit('SET_TEMPLATES', [])
        commit('SET_BLOCKS', [])
        commit('SET_BLOCK_GROUPS', [])
    }
}

export const mutations = {
    SET_USER_TOKEN(state, token) {
        state.userToken = token
        state.userGroups = token ? _.get(JWT.decode(token), 'UserGroup', []) : []
    },
    SET_USER_GROUP(state, group) {
        state.userGroup = group
    },
    SET_USER_INVITATIONS(state, payload) {
        if (_.isEqual(state.userInvitations, payload)) return
        state.userInvitations = payload
    },

    SET_ORGANISATIONS(state, organisations = []) {
        state.organisations = _.orderBy(organisations, ['initials', 'name'])
    },
    SET_ORGANISATION(state, organisation) {
        state.organisation = organisation
    },
    SET_ORGANISATION_OVERVIEW(state, payload) {
        if (_.isEqual(state.organisationOverview, payload)) return
        state.organisationOverview = payload
    },
    SET_ORGANISATION_HISTORY(state, payload) {
        if (_.isEqual(state.organisationHistory, payload)) return
        state.organisationHistory = payload
    },
    // order by username
    // update state only when users changed
    // create user map to get username from id
    SET_ORGANISATIONS_USER(state, payload) {
        const organisationUsers = _.orderBy(payload, ['username'])
        if (_.isEqual(state.organisationUsers, organisationUsers)) return // no changes, do not trigger state change

        state.organisationUsers = organisationUsers
        const userMap = {}
        state.organisationUsers.forEach(user => {userMap[user.userId] = user.username})
        state.organisationUsersMap = userMap
    },
    SET_ORGANISATIONS_USER_MAP(state, payload) {
        state.organisationUsersMap = payload
    },
    SET_ORGANISATIONS_INVITATIONS(state, payload) {
        state.organisationInvitations = payload.map(invite => {
            const metadata = Helper.parseJSON(invite.metadata)
            return {
                actionTokenId: invite.actionTokenId,
                type: invite.type,
                email: _.get(metadata, 'InviteeEmail', ''),
                organizationGroup: _.get(metadata, 'OrganizationGroup', ''),
                created: invite.created,
                expireDate: invite.expireDate,
                state: invite.status
            }
        })
    },
    SET_ORGANISATIONS_BLOCKS(state, payload) {
        if (_.isEqual(state.organisationBlocks, payload)) return
        state.organisationBlocks = payload
    },

    SET_TEMPLATES(state, templates) {
        if (_.isEqual(state.templates, templates)) return

        state.templates = templates
        const templateMap = {}
        state.templates.forEach(template => {templateMap[template.name] = template})
        state.templateMap = templateMap
        state.templatesExtended = state.templates.map(template => {
            const fields = Helper.templateToFields(template).map(field => {
                return _.pick(field, ['label', 'hint'])
            })
            const groups = Helper.templateToGroups(template).map(group => {
                return _.pick(group, ['id', 'name', 'initials', 'description', 'rows'])
            })
            template.fields = fields
            template.groups = groups
            return template
        })
    },

    SET_COACHING_UNITS(state, units) {
        state.coachingUnits = units || []
    },

    SET_COACHINGS(state, coachings) {
        state.coachings = coachings

        if (!_ISDEVX) return
        const events = []
        state.coachings.forEach(coaching => {
            if (coaching.reminderDate) {
                events.push({
                    name: `WV: ${coaching.name} - ${coaching.username}`,
                    start: coaching.reminderDate
                })
            }
        })
        state.events = events
    },

    SET_BLOCKS(state, blocks) {
        state.blocks = blocks
    },
    SET_BLOCK_GROUPS(state, groups) {
        state.blockGroups = groups
    },

    SET_COACHINGS_FILTERLIST(state, filter) {
        state.coachingsFilterList = filter
    },
    SET_COACHINGS_FILTER(state, filter) {
        state.coachingsFilter = filter
    },
    UPDATE_COACHINGS_FILTER(state, filter) {
        if (!state.organisation.organisationId) return

        state.coachingsFilter = state.coachingsFilter || {}
        state.coachingsFilter[state.organisation.organisationId] = filter
        Helper.setStore('state.coachingsFilter', state.coachingsFilter)
    },
    ADD_COACHINGS_FILTER(state, {filter, name, description, sort} = {}) {
        if (!state.organisation.organisationId) return
        if (_.isEmpty(filter)) return
        if (!description) return

        const nl = {...state.coachingsFilterList}
        nl[state.organisation.organisationId] = nl[state.organisation.organisationId] || []
        nl[state.organisation.organisationId].push({filter, name, description, sort})
        state.coachingsFilterList = nl
        Helper.setStore('state.coachingsFilterList', state.coachingsFilterList)
    },
    DELETE_COACHINGS_FILTER(state, payload) {
        if (!state.organisation.organisationId) return
        if (_.isEmpty(payload)) return

        const cfl = {...state.coachingsFilterList}
        cfl[state.organisation.organisationId] = cfl[state.organisation.organisationId] || []
        cfl[state.organisation.organisationId] = cfl[state.organisation.organisationId].filter(search => search.name !== payload.name)
        state.coachingsFilterList = cfl
        Helper.setStore('state.coachingsFilterList', state.coachingsFilterList)
    },
    SET_LINECHART_FILTER(state, filter) {
        state.lineChartFilter = filter
    },
    UPDATE_LINECHART_FILTER(state, filter) {
        if (!state.organisation.organisationId) return

        state.lineChartFilter = state.lineChartFilter || {}
        state.lineChartFilter[state.organisation.organisationId] = filter
        Helper.setStore('state.lineChartFilter', state.lineChartFilter)
    },

    SET_FETCHING(state, fetching) {
        state.fetching = {...state.fetching, ...fetching}
    }
}

export const getters = {
    userGroup(state) {
        return state.userGroup
    },
    userGroups(state) {
        return state.userGroups
    },
    userInvitations(state) {
        return state.userInvitations
    },
    organisations(state) {
        return state.organisations
    },
    organisationOverview(state) {
        return state.organisationOverview
    },
    organisationHistory(state) {
        return state.organisationHistory
    },
    organisationUsers(state) {
        return state.organisationUsers
    },
    organisationUsersMap(state) {
        return state.organisationUsersMap
    },
    organisationUsersActive(state) {
        return state.organisationUsers.filter(user => user.organizationGroup !== CONSTANTS.GROUP_DISABLED)
    },
    organisationBlocks(state) {
        return state.organisationBlocks
    },
    organisation(state) {
        return state.organisation
    },
    organisationInvitations(state) {
        return state.organisationInvitations
    },
    templates(state) {
        return state.templates
    },
    templatesExtended(state) {
        return state.templatesExtended
    },
    blocks(state) {
        return state.blocks
    },
    blockGroups(state) {
        return state.blockGroups
    },
    coachings(state) {
        return state.coachings
    },
    coachingUnits(state) {
        return state.coachingUnits
    },
    events(state) {
        return state.events
    },
    fetching(state) {
        return state.fetching
    },
    coachingsFilter(state) {
        return state.coachingsFilter
    },
    coachingsFilterList(state) {
        return state.coachingsFilterList
    },
    lineChartFilter(state) {
        return state.lineChartFilter
    },
    canEdit(state) {
        return CONSTANTS.GROUPS_EDIT.includes(state.userGroup)
    },
    canDelete(state) {
        return state.userGroup === CONSTANTS.GROUP_ADMIN
    },
    isAdmin(state) {
        return state.userGroup === CONSTANTS.GROUP_ADMIN
    }
}
